<template>
	<div>
		<div class="rightInner" v-if="isPassword == false && isPhone == false">
			<div class="title">
				<div class="titleLine"></div>
				{{$t('mypages.myInfo.title')}}
			</div>

			<div class="info" v-if="isShowEditInfo ==  false">
				<div class="labelTitle">{{$t('mypages.myInfo.section_personal')}}</div>
				<ul>
					<li>{{$t('mypages.myInfo.username_label')}} {{memberInfo.member_name}}</li>
					<li>{{$t('mypages.myInfo.nickname_label')}} {{memberInfo.nick_name}}</li>
					<li>{{$t('mypages.myInfo.email_label')}} {{memberInfo.email}}</li>
					<li>{{$t('mypages.myInfo.gender_label')}} {{ memberInfo.gender==1 ? $t('mypages.myInfo.gender_male') : $t('mypages.myInfo.gender_female') }}</li>
				</ul>
				<div class="editBtn" @click="showInfoEdit">{{$t('mypages.myInfo.edit')}}</div>
			</div>
			<div class="info" v-else>
				<div class="labelTitle">{{$t('mypages.myInfo.section_personal')}}</div>
				<div class="inputArea">
					<div class="inputLabel"><span class="required">*</span>{{$t('mypages.myInfo.username_label')}}</div>
					<input type="text" v-model="memberInfo.member_name" />
				</div>

				<div class="inputArea">
					<div class="inputLabel"><span class="required">*</span>{{$t('mypages.myInfo.nickname_label')}}</div>
					<input type="text" v-model="memberInfo.nick_name" />
				</div>
				<div class="inputArea">
					<div class="inputLabel"><span class="required">*</span>{{$t('mypages.myInfo.email_label')}}</div>
					<input type="text" v-model="memberInfo.email" />
				</div>
				<div class="inputArea">
					<div class="inputLabel"><span class="required">*</span>{{$t('mypages.myInfo.gender_label')}}</div>
					<div class="radioArea">
						<input type="radio" class="radio-input" id="pay1" value="1" v-model="memberInfo.gender" />
						{{$t('mypages.myInfo.gender_male')}}
					</div>
					<div class="radioArea">
						<input type="radio" class="radio-input" id="pay2" value="2" v-model="memberInfo.gender" />
						{{$t('mypages.myInfo.gender_female')}}
					</div>
				</div>
				<div class="btns">
					<div class="btnStyle saveBtn" @click="hideInfoEdit">{{$t('mypages.myInfo.save')}}</div>
					<div class="btnStyle cancelBtn" @click="hideInfoEditCancel">{{$t('mypages.myInfo.cancel')}}</div>
				</div>

			</div>
			<div class="info">
				<div class="labelTitle">{{$t('mypages.myInfo.section_security')}}</div>
				<ul class="safeText">
					<li class="between">
						<span>{{$t('mypages.myInfo.login_password_label')}} ***********</span>
						<span class="edit" @click="changePassword">{{$t('mypages.myInfo.modify')}}</span>
					</li>
					<li class="setPadding">{{$t('mypages.myInfo.password_change_advice')}}</li>
					<li class="between">
						<span>{{$t('mypages.myInfo.bind_phone_label')}} {{mobilestr}}</span>
						<span class="edit" @click="changePhone">{{$t('mypages.myInfo.modify')}}</span>
					</li>
					<li class="setPadding">{{$t('mypages.myInfo.phone_lost_advice')}}</li>
				</ul>
			</div>
		</div>

		<div class="rightInner" v-if="isPassword">
			<div class="title">
				<div class="titleLine"></div>
				{{$t('mypages.myInfo.account_security_title')}}
			</div>

			<div class="info">
				<div class="labelTitle">{{$t('mypages.myInfo.set_password')}}</div>
				<div class="inputArea">
					<div class="inputLabel labelWidth1">{{$t('mypages.myInfo.bind_account')}}</div>
					<div class="phoneText" v-if="currentLanguage==='zh-CN'">{{memberInfo.phone_number}}</div>
					<div class="phoneText" v-if="currentLanguage==='en-US'">{{memberInfo.email}}</div>
				</div>

				<div class="inputArea">
					<div class="inputLabel labelWidth"><span class="required">*</span>{{$t('mypages.myInfo.label_verify_code')}}</div>
					<div class="flexArea">
						<input type="text" class="xxsmallInput" :placeholder="$t('mypages.myInfo.placeholder_enter_code')" v-model="form.checkCode" />
						<button class="getBtn" v-if="!isCountdown" @click="startCountdown(60)">{{$t('mypages.myInfo.get_code')}}</button>
						<button class="getBtn" v-if="isCountdown" disabled>{{$t('mypages.myInfo.reSendSeconds',{count:countdown})}}</button>
					</div>

				</div>
				<div class="inputArea">
					<div class="inputLabel labelWidth"><span class="required">*</span>{{$t('mypages.myInfo.label_password')}}</div>
					<input type="password" :placeholder="$t('mypages.myInfo.placeholder_enter_password')" class="smallInput" v-model="form.newpassword" />
				</div>
				<div class="inputArea">
					<div class="inputLabel labelWidth"><span class="required">*</span>{{$t('mypages.myInfo.label_confirm_password')}}</div>
					<input type="password" :placeholder="$t('mypages.myInfo.placeholder_confirm_password')" class="smallInput" v-model="form.confirmpwd" />
				</div>
				<div class="btns setBtnLeft">
					<div class="btnStyle saveBtn" @click="hidePassord">{{$t('mypages.myInfo.save')}}</div>
					<div class="btnStyle cancelBtn" @click="hidePassordCancel">{{$t('mypages.myInfo.cancel')}}</div>
				</div>

			</div>

		</div>

		<div class="rightInner" v-if="isPhone">
			<div class="title">
				<div class="titleLine"></div>
				{{$t('mypages.myInfo.account_security_title')}}
			</div>

			<div class="info">
				<div class="labelTitle">{{$t('mypages.myInfo.modify_phone_title')}}</div>
				<div class="setCenter">
					<div class="steps">
						<div class="step" :class="{active : stepNum >=0}">
							<div class="flexArea">
								<div class="num">1</div>
								<div class="dot"></div>
							</div>
							<div class="stepText stepLeft">{{$t('mypages.myInfo.step_verify_sms')}}</div>
						</div>
						<div class="step" :class="{active: stepNum >= 1}">
							<div class="flexArea">
								<div class="dot"></div>
								<div class="dotArrow">></div>
								<div class="num">2</div>
								<div class="dot"></div>
							</div>
							<div class="stepText">{{$t('mypages.myInfo.step_change_phone')}}</div>
						</div>
						<div class="step" :class="{active: stepNum >= 2}">
							<div class="flexArea">
								<div class="dot"></div>
								<div class="dotArrow">></div>
								<div class="num">3</div>
							</div>
							<div class="stepText stepRight">{{$t('mypages.myInfo.step_done')}}</div>
						</div>
					</div>
					<div class="inputs" v-if="stepNum == 0">
						<div class="inputArea">
							<div class="inputLabel labelWidth1">{{$t('mypages.myInfo.bind_phone_label')}}</div>
							<div class="phoneText">{{memberInfo.phone_number}}</div>
						</div>
<!-- 				<div class="inputArea flexArea">
					<div class="inputLabel labelWidth">图形验证码：</div>
					<input type="text" :placeholder="$t('mypages.myInfo.placeholder_captcha')" class="xsmallInput" v-model="formphone.checkcode"  />
					<div class="changeArea">
						<img :src="checkCodeUrl" />
						<div class="changeText" @click="GetCaptchaImage">{{$t('mypages.myInfo.change_image')}}</div>
					</div>
				</div> -->
						<div class="inputArea">
							<div class="inputLabel labelWidth">{{$t('mypages.myInfo.label_sms_code')}}</div>
							<input type="text" :placeholder="$t('mypages.myInfo.placeholder_enter_smscode')" class="xsmallInput"  v-model="formphone.smscode" />
							<button class="getBtn" v-if="!isCountdown_old" @click="startCountdown_old(60)">{{$t('mypages.myInfo.get_code')}}</button>
							<button class="getBtn" v-if="isCountdown_old" disabled>{{$t('mypages.myInfo.reSendSeconds',{count:countdown_old})}}</button>
						</div>
						<div class="btns setBtnLeft">
							<div class="btnStyle saveBtn nextBtn" @click="nextClick">{{$t('mypages.myInfo.verify_next')}}</div>
						</div>
					</div>

					<div class="inputs" v-if="stepNum == 1">
						<div class="inputArea flexArea">
							<div class="inputLabel labelWidth">{{$t('mypages.myInfo.label_new_phone')}}</div>
							<input type="text" :placeholder="$t('mypages.myInfo.placeholder_new_phone')" class="xsmallInput" v-model="formphone.newphone" />

							</div>
						<div class="inputArea">
							<div class="inputLabel labelWidth">{{$t('mypages.myInfo.label_sms_code')}}</div>
							<input type="text" :placeholder="$t('mypages.myInfo.placeholder_enter_smscode')" class="xsmallInput" v-model="formphone.newsmscode"/>
							<button class="getBtn" v-if="!isCountdown_new" @click="startCountdown_new(60)">{{$t('mypages.myInfo.get_code')}}</button>
							<button class="getBtn" v-if="isCountdown_new" disabled>{{$t('mypages.myInfo.reSendSeconds',{count:countdown_new})}}</button>
						</div>
						<div class="btns setBtnLeft">
							<div class="btnStyle saveBtn nextBtn" @click="confirmClick">{{$t('mypages.myInfo.submit')}}</div>
						</div>
					</div>

				</div>
			</div>

		</div>


	</div>
</template>




<script>
	import axios from 'axios';
	export default {

		data() {
			return {
				isShowEditInfo: false,
				isPassword: false,
				isPhone: false,
				stepNum: 0,
				countdown: 0, // 初始倒计时秒数
				isCountdown: false,
				memberInfo: {},
				form: {
					checkCode: '',
					newpassword: '',
					confirmpwd: ''
				},
				checkCodeUrl:'',
				mobilestr:'',
				countdown_old: 0, // 初始倒计时秒数
				isCountdown_old: false,
				countdown_new: 0, // 初始倒计时秒数
				isCountdown_new: false,
				formphone: {
					checkcode: '',
					smscode: '',
					newphone: '',
					newsmscode: ''
				},
				act:'',
				currentLanguage:localStorage.getItem('locale-lang')||'zh-CN',
			}
		},
		created() {
			this.act = this.$route.query.act;
			this.GetMemberInfo();
			if(this.act=='editPsd')
			{
				this.isPassword = true
			}
			
		},
		methods: {
			showInfoEdit() {
				this.isShowEditInfo = true;
			},
			hideInfoEdit() {
				let that = this;
				this.$scUtil.axiosPut(this, 'MemberApi/UpdateMemberInfo', {
					member_name: this.memberInfo.member_name,
					nick_name: this.memberInfo.nick_name,
					gender: this.memberInfo.gender,
					userName: localStorage.getItem('username'),
				}, res => {
					//console.log(res.code);
					if (res.code == 100) {
						this.$message({
							message: res.message,
							type: "success"
						});
						this.isShowEditInfo = false;
						this.GetMemberInfo();
					} else {
						this.$message({
							message: res.message,
							type: "warning"
						});
					}
				});

			},
			hideInfoEditCancel() {
				this.isShowEditInfo = false;
				this.GetMemberInfo();
			},
			changePassword() {
				this.isPassword = true
			},
			startCountdown(seconds) {
				var currentLanguage=this.currentLanguage;
				if(currentLanguage==='zh-CN'){
						this.$scUtil.axiosPut(this, 'CommonApi/Execute', {
						cellphone: this.memberInfo.phone_number,
						operate: 'sendsms',
					}, res => {
						console.log(res.code);
						if (res.code == 100) {
							this.$message({
								message: res.message,
								type: "success"
							});
							this.isCountdown = true;
							this.countdown = seconds;

							console.log(this.countdown)
							const interval = setInterval(() => {
								if (this.countdown > 0) {
									this.countdown -= 1;
								} else {
									clearInterval(interval);
									this.isCountdown = false;
								}
							}, 1000);
						} else {
							this.$message({
								message: res.message,
								type: "warning"
							});
						}
					});
				}
				else if(currentLanguage==='en-US')
				{
					this.$scUtil.axiosPut(this, 'CommonApi/Execute', {
					email: this.memberInfo.email,
					operate: 'sendEmail',
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.$message({message: res.message,type: "success"});
						this.isCountdown = true;
						this.countdown = seconds;

						console.log(this.countdown)
						const interval = setInterval(() => {
							if (this.countdown > 0) {
								this.countdown -= 1;
							} else {
								clearInterval(interval);
								this.isCountdown = false;
							}
						}, 1000);
					}else
					{
						this.$message({message: res.message,type: "warning"});
					}

				});
				}
				
			},
			startCountdown_old(seconds) {
			
				this.$scUtil.axiosPut(this, 'CommonApi/Execute', {
					cellphone: this.memberInfo.phone_number,
					operate: 'sendsms',
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.$message({
							message: res.message,
							type: "success"
						});
						this.isCountdown_old = true;
						this.countdown_old = seconds;
			
					} else {
						this.$message({
							message: res.message,
							type: "warning"
						});
					}
			
				});
				const interval = setInterval(() => {
					if (this.countdown_old > 0) {
						this.countdown_old -= 1;
					} else {
						clearInterval(interval);
						this.isCountdown_old = false;
					}
				}, 1000);
			},
			startCountdown_new(seconds) {
			
				this.$scUtil.axiosPut(this, 'CommonApi/Execute', {
					cellphone: this.formphone.newphone,
					operate: 'sendsms',
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.$message({
							message: res.message,
							type: "success"
						});
						this.isCountdown_new = true;
						this.countdown_new = seconds;
			
					} else {
						this.$message({
							message: res.message,
							type: "warning"
						});
					}
			
				});
				const interval = setInterval(() => {
					if (this.countdown_new > 0) {
						this.countdown_new -= 1;
					} else {
						clearInterval(interval);
						this.isCountdown_new = false;
					}
				}, 1000);
			},
			hidePassord() {
				if (this.form.checkCode == '') {
					this.$message({
						message: this.$t('mypages.myInfo.validation.checkcode_required'),
						type: "warning"
					});
					return;
				}
				if (this.form.newpassword == '') {
					this.$message({
						message: this.$t('mypages.myInfo.validation.newpassword_required'),
						type: "warning"
					});
					return;
				}
				if (this.form.confirmpwd == '') {
					this.$message({
						message: this.$t('mypages.myInfo.validation.confirmpwd_required'),
						type: "warning"
					});
					return;
				}
				this.$scUtil.axiosPut(this, 'MemberApi/ForgetPwd', {
					cellphone: this.memberInfo.phone_number,
					email: this.memberInfo.email,
					checkCode: this.form.checkCode,
					newpassword: this.form.newpassword,
					confirmpwd: this.form.confirmpwd,
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.$message({
							message: this.$t('mypages.myInfo.password_change_success'),
							type: "success"
						});
						this.isPassword = false

					} else {
						this.$message({
							message: this.$t('mypages.myInfo.password_change_failed'),
							type: "warning"
						});
					}

				});

			},
			hidePassordCancel() {
				this.isPassword = false;
				this.GetMemberInfo();
			},
			changePhone() {
				//this.GetCaptchaImage();
				this.isPhone = true
			},
			nextClick() {
				// if(this.formphone.checkcode=='')
				// {
				// 	this.$message({message: this.$t('mypages.myInfo.enter_captcha'),type: "warning"});
				// 	return;
				// }
				if(this.formphone.smscode=='')
				{
					this.$message({message: this.$t('mypages.myInfo.enter_old_smscode'),type: "warning"});
					return;
				}
				this.stepNum = this.stepNum + 1
			},
			confirmClick() {
				if(this.formphone.newphone=='')
				{
					this.$message({message: this.$t('mypages.myInfo.enter_newphone'),type: "warning"});
					return;
				}
				if(this.formphone.newsmscode=='')
				{
					this.$message({message: this.$t('mypages.myInfo.enter_newsmscode'),type: "warning"});
					return;
				}		
				this.$scUtil.axiosPut(this, 'MemberApi/UpdatePhone', {
					//checkcode: this.formphone.checkcode,
					smscode: this.formphone.smscode,
					newsmscode: this.formphone.newsmscode,
					newphone: this.formphone.newphone,
					username:localStorage.getItem('username'),
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.$message({
							message: this.$t('mypages.myInfo.phone_update_success'),
							type: "success"
						});
						this.isPhone = false
						this.stepNum = 0
						this.GetMemberInfo();
				
					} else {
						this.$message({
							message: res.message,
							type: "warning"
						});
						this.stepNum = 0
					}
				
				});
	
				
			},
			GetMemberInfo() {
				this.$scUtil.axiosPost(this, 'MemberApi/GetMemberInvoice', {
					userName: localStorage.getItem('username'),
				}, res => {
					//console.log(res.code);
					if (res.code == 100) {
						this.memberInfo = res.data;
						this.mobilestr= this.memberInfo.phone_number.substring(0,3)+'*****'+ this.memberInfo.phone_number.substring(this.memberInfo.phone_number.length-3,this.memberInfo.phone_number.length);
					}

				});
			},
			// GetCaptchaImage() {
			// 		this.$scUtil.axiosPostImage(this, 'CommonApi/GetCaptchaImage', res => {
			// 		//console.log(res.code);
			// 		this.checkCodeUrl=res;

			// 	});
			// },
		}
	}
</script>

<style scoped>
	.rightInner {
		width: 958px;
	}

	.title {
		font-size: 14px;
		color: #000000;
		display: flex;
		align-items: center;
		height: 52px;
		border-bottom: 1px solid #e2e2e2;
		padding-left: 20px;
		background-color: #fff;
	}

	.titleLine {
		width: 4px;
		height: 14px;
		background-color: #0380fe;
		margin-right: 15px;
	}

	.info {
		width: 100%;
		padding: 20px 20px 0 20px;
		box-sizing: border-box;
		background-color: #fff;
	}

	.info:nth-last-child(1) {
		padding-bottom: 20px;
	}

	.info ul li {
		font-size: 13px;
		color: #333333;
		line-height: 40px;
		list-style: none;
	}

	.editBtn {
		width: 117px;
		height: 33px;
		background-color: #0380fe;
		color: #fff;
		font-size: 13px;
		text-align: center;
		line-height: 33px;
		margin-top: 15px;
		border-radius: 3px;
	}

	.labelTitle {
		font-size: 14px;
		color: #000000;
		font-weight: bolder;
		line-height: 33px
	}

	ul.safeText li {
		color: #888;
	}

	.between {
		display: flex;
		justify-content: space-between;
	}

	.setPadding {
		padding-left: 70px;
		box-sizing: border-box;
	}

	.edit {
		font-size: 13px;
		color: #0380fe;
		padding-right: 20px;
		box-sizing: border-box;
		cursor: pointer;
		text-decoration: underline;
	}


	.inputArea {
		display: flex;
		align-items: baseline;
		margin-bottom: 20px;
	}

	.inputArea input[type=text],
	.inputArea input[type=password] {
		width: 319px;
		height: 32px;
		border: 1px solid#e2e2e2;
		padding: 0 18px;
		color: #333333;
	}

	.inputLabel {
		width: 67px;
		text-align: left;
		font-size: 13px;
		color: #333333;
	}


	.btns {
		cursor: pointer;
		display: flex;
		padding-bottom: 20px;
	}

	.btnStyle {
		width: 97px;
		height: 33px;
		font-size: 12px;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.saveBtn {
		border: 1px solid #0380fe;
		background: #0380fe;
		color: #fff;
		margin-right: 20px;
	}

	.cancelBtn {
		border: 1px solid #d9d9d9;
		background: #fff;
		color: #333;
	}

	.radioArea {
		width: 70px;
		font-size: 13px;
	}

	.required {
		color: #ff0000;
	}

	.labelTitle+.inputArea {
		margin-top: 10px;
	}

	.setBtnLeft {
		padding-left: 105px;
	}

	.labelWidth {
		width: 90px;
		margin-left: 15px;
	}

	.labelWidth1 {
		width: 100px;
	}

	.inputArea input[type=text].smallInput {
		width: 200px;
	}

	.inputArea input[type=text].xsmallInput {
		width: 150px;
	}

	.inputArea input[type=text].xxsmallInput {
		width: 100px;
	}

	.inputArea input[type=password].smallInput {
		width: 220px;
	}


	.getBtn {
		width: 103px;
		height: 32px;
		border: 1px solid #0380fe;
		color: #0380fe;
		background: #fff;
		margin-left: 15px;
		cursor: pointer;
	}

	.flexArea {
		display: flex;
		align-items: center;
	}

	.phoneText {
		font-size: 13px;
		color: #333333;
	}

	.steps {
		display: flex;
		align-items: center;
	}

	.step {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.dot::before {
		content: '• • • • • •';
		/* 根据需要添加圆点 */
		letter-spacing: 3px;
		/* 设置圆点之间的间距 */
		color: #9a9a9a;
	}

	.num {
		width: 30px;
		height: 30px;
		border-radius: 50px;
		background: #cecece;
		color: #fff;
		font-size: 14px;
		font-weight: bolder;
		text-align: center;
		line-height: 30px;
		margin: 0 15px;
	}

	.step.active .num {
		background: #5fcb2f;
	}

	.step.active .dot::before {
		color: #5fcb2f;
	}

	.step:nth-child(2),
	.step:nth-child(3) {
		margin-left: 10px;
	}

	.btnStyle.nextBtn {
		width: 161px;
		height: 41px;
	}

	.grayBtn {
		background: #cdcdcd;
		color: #fff;
		border: 1px solid #cdcdcd;
	}

	.changeArea {
		display: flex;
		align-items: flex-end;
		margin-left: 17px;
	}

	.changeText {
		margin-left: 10px;
	}

	.setCenter {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.inputs {
		margin-top: 40px;
	}

	.stepText {
		font-size: 14px;
		font-weight: bolder;
		color: #000;
		margin-top: 10px;
	}

	.stepLeft {
		text-align: left;
		width: 100%;
	}

	.stepRight {
		text-align: right;
		width: 100%;
		padding-right: 40px;
	}

	.dotArrow {
		transform: scaleY(2);
		color: #cecece;
		margin: 0 5px 0 10px;
	}

	.step.active .dotArrow {
		color: #5fcb2f;
	}
</style>